<template>
  <div>
    <v-expansion-panels dense flat>
      <v-expansion-panel :key="index + '_' + entry.key"
                         @change="heightChanged()"
                         style="border-radius: 0"
                         v-for="(entry, index) in items.categories">
        <v-expansion-panel-header
          style="color: #02073A; font-size: 18px; padding: 20px 30px 0 15px; background-color: #F7F7F7">
          {{ entry.title }}
          <span class="pl-3"
                style="font-size: 12px; line-height: 18px; vertical-align: bottom !important;"
                v-if="countSelected(entry.key) > 0">({{ countSelected(entry.key) }})</span>

        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0"
                                   color="#F7F7F7">
          <div :key="index + '_' + categoryIndex"
               v-for="(category,categoryIndex)  in entry.categories">
            <v-checkbox :input-value="isSelected(category.id)"
                        @change="(newVal) => checkboxChanged(category, newVal)"
                        :class="!categoryIsEnabled(category.id) ? 'disabled-category pa-0 fin-checkbox d-inline-flex' : 'pa-0 fin-checkbox d-inline-flex'"
                        dense
                        :disabled="!categoryIsEnabled(category.id)"
                        hide-details/>
            <span slot="message" :class="!categoryIsEnabled(category.id) ? 'disabled-category' : ''">
                <fin-lexicon-text :text="category.title"
                                  auto-solve/>
            </span>
            <v-btn v-if="!categoryIsEnabled(category.id)" small text
                   @click="openAboDialog">
              <v-icon
                icon
                small
                color="fin-color-primary-dark"
              >
                mdi-lock
              </v-icon>
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"

export default {
  name: 'fin-screener-second-filter-step',
  components: {FinLexiconText},
  mixins: [
    PriceModel
  ],
  props: {
    value: {
      type: Array
    },
    items: {
      type: Object
    },
    screenerType: {
      type: String
    },
    disabledFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        console.log("secondFilterStep computed model set", newVal)
        this.$emit('input', newVal)
      }
    },
    availableFilters() {
      if (!this.items) return []

      const filtersByPriceModel = this.priceModelEnabledAndLevels(this.priceModelFeatureId)

      if (filtersByPriceModel.length === 0 || filtersByPriceModel[0].id === 'SCREENER_ETF_UNLIMITED' || filtersByPriceModel[0].id === 'SCREENER_SHARE_UNLIMITED') {
        const allFilters = []
        this.items.categories.forEach(cat => cat.categories.forEach(filter => allFilters.push(filter.id)))
        return allFilters
      }

      return this.priceModelEnabledAndLevels(this.priceModelFeatureId).reduce((acc, item) => {
        const cat = this.items.categories.find(cat => cat.key === item.id)
        if (cat) cat.categories.forEach(filter => acc.push(filter.id))
        return acc
      }, [])
    },
    priceModelFeatureId() {
      if (this.$route.path.includes('/etfScreener')) {
        return PRICEMODEL_FEATURE_IDS.ETF_SCREENER.id
      } else {
        return PRICEMODEL_FEATURE_IDS.SHARE_SCREENER.id
      }
    }
  },
  methods: {
    openAboDialog() {
      EventBus.$emit('showSubscriptionPopup', this.priceModelFeatureId, PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY, true)
    },
    categoryIsEnabled(selectedSecondLevelItem) {
      return this.availableFilters.includes(selectedSecondLevelItem)
    },
    heightChanged() {
      setTimeout(() => {
        this.$emit('heightChanged')
      }, 300)
    },
    checkboxChanged(entry, newVal) {
      const model = this.getModel(entry)

      if (!newVal) {
        // uncheck checkbox
        if (entry.histograms && entry.histograms.items && entry.histograms.items.length > 0) {
          model.min = null
          model.max = null
          model.filterType = "rangeFilter"
        } else if (entry.filterValues) {
          model.values = []
          model.filterType = "valuesFilter"
        }

        this.model = this.model.filter(itemModel => {
          console.log("checkboxChanged uncheck => itemModel, entry", itemModel, entry)
          return itemModel.item.itemId !== entry.itemId && itemModel.item.id !== entry.id
        })
      } else {
        // check checkbox
        if (model.filterType === 'valuesFilter') {
          // select none by default
          model.values = [] // entry.filterValues && entry.filterValues.values ? entry.filterValues.values : []
        } else if (model.filterType === 'rangeFilter') {
          model.min = null
          model.max = null
        } else {
          console.error("checkboxChanged unknown filterType", model.filterType)
        }
        this.model.unshift(model)
      }

      console.log('checkboxChanged resulting model', this.model)
    },
    isSelected(id) {
      let result = false
      const entry = this.model.find(itemModel => itemModel.item.id === id)
      if (entry) {
        result = true
      }
      return result
    },
    getModel(entry) {
      let result = this.model.find(item => item.item.id === entry.id)
      if (!result) {
        result = {
          item: {
            id: entry.id,
            name: entry.title,
            shortName: entry.shortName,
            itemId: entry.key,
            unit: entry.unit,
            displayType: entry.displayType
          },
          filterType: entry.filterType
        }
        console.log("getModel", entry, this.screenerType, result)
        if (entry.histograms && entry.histograms.items && entry.histograms.items.length > 0) {
          result.min = null
          result.max = null
          result.filterType = "rangeFilter"
        } else if (entry.filterValues) {
          result.values = []
          result.filterType = "valuesFilter"
        } else {
          console.error("getModel an error occured, please check if this entry has histograms or filterValues: this.screenerType, entry", this.screenerType, entry)
        }
      }

      if (!result.filterType) {
        result.filterType = result.values ? result.filterType = 'valuesFilter' :
          result.min && result.max ? result.filterType = 'rangeFilter' : undefined
      }

      return result
    },
    /**
     *
     * @param key First level key
     * @returns {Number} Count of selected items of given first level item
     */
    countSelected(key) {
      const selected = this.model
      let counter = 0
      const firstLevelItem = this.items.categories.find(firstLevel => firstLevel.key === key)
      if (firstLevelItem) {
        firstLevelItem.categories.forEach(secLevel => {
          if (selected.find(selectedItem => secLevel.key === selectedItem.item.itemId)) {
            counter++
          }
        })
      }
      return counter
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep .v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active {
  border-bottom: 1px solid #cfd1d3;
  padding-bottom: 20px;
  background-color: #f5f8f9;
}

::v-deep .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
  font-weight: bold;
  color: $fin-color-primary-dark;
}

::v-deep .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
  flex: 0 auto;
}

::v-deep .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child)::after {
  border-color: transparent !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 15px;
}

::v-deep .mdi-checkbox-blank-outline {
  justify-content: flex-start;
  padding-left: 5px;
}

::v-deep .fin-checkbox .v-label {
  color: $fin-color-primary-dark;
}

.disabled-category {
  opacity: 50%;
}
</style>
